import { render, staticRenderFns } from "./ContactUsTopicView.vue?vue&type=template&id=5023625e"
import script from "./ContactUsTopicView.vue?vue&type=script&lang=js"
export * from "./ContactUsTopicView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports